import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  standalone: false,
  name: 'bringozDay'
})
export class BringozDayPipe implements PipeTransform {

  constructor(@Inject('splitService') private splitService) {}

  transform(object: any, ref: string, format: 'long' | 'short' = 'long', timeZoneId?: string): string {
    if (object && object[ref]) {
      return this.formatDay(object[ref], format, timeZoneId);
    } else {
      return '---';
    }
  }

  private formatDay(date: any, format: 'long' | 'short', timeZoneId?: string): string {
    let momentDate;

    if (timeZoneId) {
      momentDate = moment(date).tz(timeZoneId);
    } else {
      momentDate = moment(date);
    }

    // Format 'long' returns full day name (Monday, Tuesday, etc.)
    // Format 'short' returns abbreviated day name (Mon, Tue, etc.)
    return format === 'long' ? momentDate.format('dddd') : momentDate.format('ddd');
  }
}
